/**
 * @generated SignedSource<<ebe34c877973f61017ee7a3238c888c7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DetailFilterListCategory_category$data = {
  readonly categoryname: string | null | undefined;
  readonly col: string | null | undefined;
  readonly filteritems: ReadonlyArray<{
    readonly filtervalue: string | null | undefined;
    readonly label: string | null | undefined;
  } | null | undefined> | null | undefined;
  readonly info: {
    readonly " $fragmentSpreads": FragmentRefs<"CategoryInfo_info">;
  } | null | undefined;
  readonly " $fragmentType": "DetailFilterListCategory_category";
};
export type DetailFilterListCategory_category$key = {
  readonly " $data"?: DetailFilterListCategory_category$data;
  readonly " $fragmentSpreads": FragmentRefs<"DetailFilterListCategory_category">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DetailFilterListCategory_category",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "col",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "categoryname",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CategoryInfo",
      "kind": "LinkedField",
      "name": "info",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CategoryInfo_info"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DetailFilterItem",
      "kind": "LinkedField",
      "name": "filteritems",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "filtervalue",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DetailFilterListCategory",
  "abstractKey": null
};

(node as any).hash = "d9d7f7cbaa15ac5ff13ee43f8af4c304";

export default node;
